import { FormControl, FormGroup } from "@angular/forms";
import { BaseObservableForm } from "apps-module/app/shared-library/forms/base-observable.form";
import { nameof } from "apps-module/app/shared-library/utils/common.utils";

import { DatesFilterOptions } from "../components/search-filters/dates-filter/dates-filter-options.enum";
import { SearchFilterModel } from "../models/search-filter.model";

export class SearchForm extends BaseObservableForm<SearchFilterModel> {
    public static createForm(initialSearchParams: SearchFilterModel): SearchForm {
        const formGroup = new FormGroup({
            searchContext: new FormControl<string>(initialSearchParams.searchContext),
            searchText: new FormControl<string>(initialSearchParams.searchText),
            pageNumber: new FormControl<number>(initialSearchParams.pageNumber),
            pageSize: new FormControl<number>(initialSearchParams.pageSize),
            sortOption: new FormControl<string>(initialSearchParams.sortOption),
            location: new FormControl<string>(initialSearchParams.location),
            distance: new FormControl<number>(initialSearchParams.distance),
            categories: new FormControl<Array<string>>(initialSearchParams.categories),
            // dateFilterType: new FormControl<DatesFilterOptions>(initialSearchParams.dateFilterType),
            // fromDate: new FormControl<string>(initialSearchParams.fromDate),
            // toDate: new FormControl<string>(initialSearchParams.toDate),
            viewMap: new FormControl<number>(initialSearchParams.viewMap),
            viewMode: new FormControl<number>(initialSearchParams.viewMode)
        });

        return new SearchForm(formGroup, initialSearchParams);
    }

    public get nativeForm(): FormGroup { return this.formInstance; }

    public get searchContext(): FormControl<string> { return this.formInstance.get(nameof<SearchFilterModel>("searchContext")) as FormControl<string>; }
    public get searchText(): FormControl<string> { return this.formInstance.get(nameof<SearchFilterModel>("searchText")) as FormControl<string>; }
    public get pageNumber(): FormControl<number> { return this.formInstance.get(nameof<SearchFilterModel>("pageNumber")) as FormControl<number>; }
    public get pageSize(): FormControl<number> { return this.formInstance.get(nameof<SearchFilterModel>("pageSize")) as FormControl<number>; }
    public get sortOption(): FormControl<string> { return this.formInstance.get(nameof<SearchFilterModel>("sortOption")) as FormControl<string>; }
    public get location(): FormControl<string> { return this.formInstance.get(nameof<SearchFilterModel>("location")) as FormControl<string>; }
    public get distance(): FormControl<number> { return this.formInstance.get(nameof<SearchFilterModel>("distance")) as FormControl<number>; }
    public get categories(): FormControl<Array<string>> { return this.formInstance.get(nameof<SearchFilterModel>("categories")) as FormControl<Array<string>>; }
    // public get dateFilterType(): FormControl<DatesFilterOptions> { return this.formInstance.get(nameof<SearchFilterModel>("dateFilterType")) as FormControl<DatesFilterOptions>; }
    // public get fromDate(): FormControl<string> { return this.formInstance.get(nameof<SearchFilterModel>("fromDate")) as FormControl<string>; }
    // public get toDate(): FormControl<string> { return this.formInstance.get(nameof<SearchFilterModel>("toDate")) as FormControl<string>; }
    public get viewMap(): FormControl<number> { return this.formInstance.get(nameof<SearchFilterModel>("viewMap")) as FormControl<number>; }
    public get viewMode(): FormControl<number> { return this.formInstance.get(nameof<SearchFilterModel>("viewMode")) as FormControl<number>; }

    private constructor(
        formInstance: FormGroup,
        initialSearchParams: SearchFilterModel
    ) {
        super(formInstance, initialSearchParams);
    }

    public searchByText(): void {
        this.submit({
            pageNumber: 1
            // dateFilterType: this.initialFormState.dateFilterType,
            // fromDate: this.initialFormState.fromDate,
            // toDate: this.initialFormState.toDate
        });
    }

    public searchByLocation(): void {
        this.submit({
            pageNumber: 1,
            searchText: this.initialFormState.searchText
        });
    }

    public searchByCategories(): void {
        this.submit({
            pageNumber: 1,
            searchText: this.initialFormState.searchText,
            location: this.initialFormState.location,
            distance: this.initialFormState.distance
            // dateFilterType: this.initialFormState.dateFilterType,
            // fromDate: this.initialFormState.fromDate,
            // toDate: this.initialFormState.toDate
        });
    }

    public searchByDates(): void {
        this.submit({
            pageNumber: 1,
            searchText: this.initialFormState.searchText
        });
    }

    public searchByPageNumber(): void {
        this.submit({
            searchText: this.initialFormState.searchText,
            location: this.initialFormState.location,
            distance: this.initialFormState.distance,
            categories: this.initialFormState.categories
            // dateFilterType: this.initialFormState.dateFilterType,
            // fromDate: this.initialFormState.fromDate,
            // toDate: this.initialFormState.toDate
        });
    }

    public applySearchOptions(): void {
        this.submit({
            pageNumber: 1,
            searchText: this.initialFormState.searchText,
            location: this.initialFormState.location,
            distance: this.initialFormState.distance,
            categories: this.initialFormState.categories
        });
    }
}
